

module.exports = __webpack_require__.stylable.create(
    "FontUpgrade3715434959",
    {"classes":{"root":"FontUpgrade3715434959__root"},"vars":{"wsr-font-family":"--wsr-font-family","wsr-font-weight-regular":"--wsr-font-weight-regular","wsr-font-weight-bold":"--wsr-font-weight-bold","wix-font-stack":"--wix-font-stack","wix-font-weight-regular":"--wix-font-weight-regular","wix-font-weight-bold":"--wix-font-weight-bold"},"stVars":{},"keyframes":{}},
    ".FontUpgrade3715434959__root{--wsr-font-family: var(--wix-font-stack);--wsr-font-weight-regular: var(--wix-font-weight-regular);--wsr-font-weight-bold: var(--wix-font-weight-bold)}",
    1,
    "FontUpgrade3715434959",
    __webpack_require__.stylable.$
);
